import { render, staticRenderFns } from "./monitoringLabel.vue?vue&type=template&id=72ee30b3&scoped=true"
import script from "./monitoringLabel.vue?vue&type=script&lang=js"
export * from "./monitoringLabel.vue?vue&type=script&lang=js"
import style0 from "./monitoringLabel.vue?vue&type=style&index=0&id=72ee30b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee30b3",
  null
  
)

export default component.exports